import React from "react";
import styled from "styled-components";
import { Cell } from "@sonder/ui/source/styled/fragments/Table";

const EmptyRowMessageCell = styled(Cell)`
  grid-column: 2 / -2;
`;

interface EmptyRowProps {
  label: string;
  loadingLabel?: string;
  errorLabel?: string;
}
export const EmptyRow = ({
  label,
  loadingLabel,
  errorLabel,
}: EmptyRowProps) => (
  <>
    <Cell lastRow rowStart />
    <EmptyRowMessageCell lastRow>
      {errorLabel}
      {!errorLabel && loadingLabel}
      {!errorLabel && !loadingLabel && label}
    </EmptyRowMessageCell>
    <Cell lastRow rowEnd />
  </>
);
